import React, { Component } from 'react'
import ClearButton from './ClearButton'
import './TrippleButton.css'

export default class TrippleButton extends Component {
  render () {
    return (
      <div className='top-buttons-wrap'>
        <ClearButton
          onClick={() => this.props.onChangeTab && this.props.onChangeTab.call(null, 'Q&A')}
          text='QUESTIONS'
          active={this.props.activeTab === 'Q&A'} />
        <ClearButton
          onClick={() => this.props.onChangeTab && this.props.onChangeTab.call(null, 'ANSWERED')}
          text='ANSWERS'
          active={this.props.activeTab === 'ANSWERED'} />
        <ClearButton
          onClick={() => this.props.onChangeTab && this.props.onChangeTab.call(null, 'POLLS')}
          text='POLLS'
          active={this.props.activeTab === 'POLLS'} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/buttons/TrippleButton.js